/*******************************************************************************
 * Copyright (c) 2019 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *******************************************************************************/

import React from 'react'
import { Link } from 'react-router-dom'
import {  Button, Typography } from '@mui/material'

  

const ErrorPage = () => {
 

    return (
      <>
        <Typography gutterBottom variant="h5">
           Oh No! - Unknown Error
        </Typography>

        <Button component={Link} to="/" variant="contained" color="primary">
          Return to the Dashboard
        </Button>
      </>
    ) 
}
 
export default ErrorPage;